import $ from 'jquery'
import Isotope from 'isotope-layout'
import imagesLoaded from 'imagesloaded'
import { debounce, getTextNodesIn } from '../functions'

imagesLoaded.makeJQueryPlugin($)


let adviceIso = ''

const parent = $('.js-advices-iso')
if (parent.length != 0) {
  adviceIso = new Isotope('.js-advices-iso', {
    itemSelector: '.js-advices-iso-item',
    transitionDuration: 400,
    percentPosition: true,
    masonry: {
      // use element for option
      columnWidth: '.grid-sizer'
    }
  })

  parent.imagesLoaded(function () {
    adviceIso.layout()
  })

  $('.js-advices-iso-search').keyup( function () {
    arrangeAdvicesIso();
  })

  $('.js-advices-select').on('change', function () {
    arrangeAdvicesIso();
  })
}

function arrangeAdvicesIso () {
  adviceIso.arrange({
    filter: function () {
      const posts = $(this)
      const vals = [$('.js-advices-select').val()]

      const attr = posts.attr('data-categories')
      const categories = attr.includes(',') ? attr.split(',') : [attr]
      const newCategories = categories.map(Number)
      let hasCategory = false

      if (vals[0] == null) {
        hasCategory = true
      }

      if (newCategories.length > 0) {
        for (let i = 0; i < vals.length; i++) {
          if (
              newCategories.includes(parseInt(vals[i])) ||
              vals[i] === 'all'
          ) {
            hasCategory = true
          }
        }
      }

      const qsRegex = new RegExp($('.js-advices-iso-search').val(), 'gi')
      const text = getTextNodesIn(posts[0])

      let hasText = qsRegex ? text.match(qsRegex) : true

      return hasCategory && hasText
    },
  })
}